import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from './auth_context';
import { useUser } from './user_context';
import AuthFunctions from './auth_utils';
import { userData } from '../data/data_users';
import { authTokenService } from '../api/api';
import Audit from '../utils/audit_util';

function AuthCallback() {
    const { setToken, setIsAuthReady } = useAuth();
    const { setUser, setIsLoading } = useUser();
    const navigate = useNavigate();

    useEffect(() => {
        const handleAuthentication = async () => {
            const urlParams = new URLSearchParams(window.location.search);
            const authCode = urlParams.get('code');
            try {
                const data = await authTokenService.fetchToken(authCode);
                if (data && data.token && data.token.id_token) {
                    document.cookie = `sid=${data.token.id_token}; path=/`;
                    setToken(data.token.id_token);
                    setIsAuthReady(true);
                    
                    // Fetch user information after successful authentication
                    try {
                        setIsLoading(true);
                        const response = await userData.getUserInfo();
                        // Extract user data from the response structure
                        if (response && response.success && response.user) {
                            setUser(response.user);
                        } else {
                            console.error('Invalid user response structure:', response);
                        }
                    } catch (userError) {
                        console.error('Error fetching user info:', userError);
                        // Continue with login even if user info fetch fails
                    } finally {
                        setIsLoading(false);
                    }
                    
                    Audit.LogUserAction('login.completed', 'login', 'success');
                    navigate('/');
                } else {
                    console.error('Invalid token structure:', data);
                    navigate('/login');
                }
            } catch (error) {
                console.error('Authentication error:', error);
                navigate('/login');
            }
        };
        handleAuthentication();
    }, [setToken, setIsAuthReady, setUser, setIsLoading, navigate]); 

    return (
        <div>
            Processing authentication...
        </div>
    );
}

export default AuthCallback;
